import { useNavigate } from "react-router-dom";
import {
  Body as BaseBody,
  ContentContainer,
  Header,
  NavigateBeforeButton,
} from "../../components";
import { RequestType } from "../../interfaces";
import { Card } from "./components/Card";
import { useCallback } from "react";
import { Box, styled, Theme, Typography, useMediaQuery } from "@mui/material";

const DocumentTypesContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 24,
  width: "100%",
  padding: 0,
}));

const Body = styled(BaseBody)(() => ({
  alignItems: "normal",
}));

const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export function NewDocumentType() {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const navigate = useNavigate();

  const handleDocumentTypeClick = useCallback(
    (documentType: RequestType) => {
      navigate(`/app/nuevo-documento/paciente`, {
        state: { documentType },
      });
    },
    [navigate]
  );

  return (
    <>
      <Header
        useMekiDocIcon={isDesktop}
        title={!isDesktop ? "Nuevo documento" : undefined}
        titleColor="black"
        left={
          <NavigateBeforeButton onClick={() => navigate("/app/solicitudes")} />
        }
      />
      <ContentContainer disableGutters>
        <Body>
          <Title variant="h4" fontWeight={"medium"}>
            Nuevo documento
          </Title>
          <DocumentTypesContainer>
            {Object.values(RequestType).map((documentType) => (
              <Card
                key={documentType}
                documentType={documentType}
                onClick={() => handleDocumentTypeClick(documentType)}
              />
            ))}
          </DocumentTypesContainer>
        </Body>
      </ContentContainer>
    </>
  );
}
